export function useFormattedDate() {
  const formatDate = (dateString: string): string => {
    // Split the input date (assuming 'YYYY-MM-DD' format)
    const [year, month, day] = dateString.split('-').map(Number);

    // Create a date with local time to avoid UTC conversion issues
    const date = new Date(Date.UTC(year, month - 1, day));

    const returnDate = `${month}/${day}/${year}`;

    return returnDate;
  };

  return {
    formatDate
  };
}
